export default __webpack_public_path__ + "static/media/icon_maintenance_completed.86cc33e6.svg";